import React, { useEffect, useState } from 'react';
import styles from './AdminExerciseCreate.module.scss';
import AdminSinglePage from '../AdminSinglePage/AdminSinglePage';
import { exerciseSingle } from '../../../redux/actions/app/exerciseSingle';
import { resetExerciseCreate, resetExerciseEdit, resetExerciseSingle } from '../../../redux/slices/app.slice';
import { useDispatch } from 'react-redux';
import { exerciseEdit } from '../../../redux/actions/app/exerciseEdit';
import { useNavigate, useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Loading from '../../../components/admin/Loading/Loading';
import { exerciseCreate } from '../../../redux/actions/app/exerciseCreate';

const AdminExerciseCreate = () => {
  const data = [
    [
      {
        label: 'Видео',
        type: 'upload',
        name: 'linkVideo',
        width: '90%',
      },
      [
        {
          label: 'Название',
          type: 'text',
          name: 'name',
        },
        { label: 'Порядок', type: 'number', name: 'order' },
        { label: 'Описание', type: 'textarea', name: 'desc', required: false },
      ],
    ],
  ];
  const [fields, setFields] = useState(data);

  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    exerciseEdit: { data: exerciseEditData, loading: exerciseEditLoading },
    exerciseCreate: { data: exerciseCreateData, loading: exerciseCreateLoading },
  } = useSelector((state) => state.app);
  const navigate = useNavigate();
  useEffect(() => {
    if (exerciseCreateData) {
      toast.success('Упражнение создано');
      navigate('/admin/exercises');
      dispatch(resetExerciseCreate());
    }
  }, [exerciseCreateData]);

  useEffect(() => {
    if (exerciseEditData) {
      toast.success('Упражнение обновление');
      navigate('/admin/exercises');
      dispatch(resetExerciseEdit());
    }
  }, [exerciseEditData]);
  return (
    <>
      <AdminSinglePage
        isCreate
        isBlock={false}
        isDelete={false}
        onSubmit={(data) => {
          console.log(data);
          dispatch(exerciseCreate(data));
        }}
        reset={resetExerciseSingle}
        fetch={exerciseSingle}
        sliceName={'app'}
        actionName={'exerciseSingle'}
        fields={fields}
        isSave
        pathList="/admin/exercises"
        propName={'exercise'}
        type={'USER'}
      />
      {exerciseEditLoading && <Loading />}
    </>
  );
};

export default AdminExerciseCreate;
